export default "__VITE_PUBLIC_ASSET__97d9052d__"